import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-rostering-addmorevehicle',
  templateUrl: './rostering-addmorevehicle.component.html',
  styleUrls: ['./rostering-addmorevehicle.component.css']
})
export class RosteringAddmorevehicleComponent implements OnInit {
  
  public selectedEmpCounts = 0;
  public selectedVehicleCounts = 0;
  public selectedVehicleSeats = 0; 
  public vehicles = [];
  public selectedvehicles = [];
  public optionTitlecase:boolean = false;

  @Input() routeID
  @Input() title = "'Vehicle Selection'"
  @Input() popup = false 
  @Input() public set selectedEmp(val:any){
    this.selectedEmpCounts = Object.keys(val).length;
  };
  @Input('vehicleList') vehiclelists;
  @Input() public set selectedVeh(val:any){
    if(this.vehiclelists.length > 0){
      this.selectedVehicleSeats = 0;
      this.vehiclelists.filter((veh)=>this.selectedVehicleSeats+=Number(veh.badge));
    }
  };
  
  @Output() closeEvent: any = new EventEmitter();
  @Output() result: any = new EventEmitter();

  
  constructor(
    private api: ApiService,
    private swal: SweetAlert,
  ) { }

  ngOnInit(): void {
  }
  
  actionMulti(selected) {
    this.selectedvehicles = selected;
    this.vehicles = selected.map((veh) => { return veh.value; });
    this.selectedVehicleCounts = 0;
    this.selectedVehicleSeats = 0;
    selected.filter((veh)=>{
      this.selectedVehicleCounts++;
      this.selectedVehicleSeats+=Number(veh.badge);
    });
  }
  onSubmit(){
    if(this.vehicles.length > 0){

      let obj = {
        routeID:this.routeID,
        vehicle:this.vehicles,
      }
      this.api.transportMangerRouteUpdate(obj).then((res: any) => {
        if (res.status == 'success') {
          //this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.result.emit(this.selectedvehicles);
          this.closeEvent.emit(false);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      });
    }
  }
}


